<div class="desktop-width-limiter detail-page page-padding">
  @if (!loading && !error && profile) {
    <mat-card class="widget">
      <h1 class="pageTitle">
        @if (!!profile.name && profile.name !== ' ') {
          <span>{{
            profile.name
          }}</span>
        }
        @if (!profile.name || profile.name === ' ') {
          <span>{{
            profile.userName
          }}</span>
        }
      </h1>
      <div class="page-content">
        <div class="page-attributes">
          <div class="profile-image">
            <div class="image-section">
              <img
                [src]="getProfilePicture()"
                onerror="this.src = '/assets/images/user.png';"
                class="user-image"
                [alt]="'Afbeelding reporter'"
                />
                @if (profile.isReporter) {
                  <img
                    class="reporter-logo"
                    src="/assets/images/logo_tekst_streapp_reporter_03.svg"
                    [alt]="'StreApp Reporter'"
                    />
                }
              </div>
              <div class="reporting-button">
                <!-- Rapporteer gebruiker -->
                @if (isLoggedIn()) {
                  <reporting-button
                    [userId]="userId"
                    [buttonTitle]="'report.report_user'"
                  ></reporting-button>
                }
              </div>
            </div>
            @if (profile.amountOfStreApps) {
              <div class="attribute">
                <h2>{{ "reporters.detail.amount" | translate }}</h2>
                <span class="category">{{ profile.amountOfStreApps }}</span>
              </div>
            }
            @if (profile.profile) {
              <div class="attribute">
                <h2>{{ "reporters.detail.profile" | translate }}</h2>
                <span class="category">{{ profile.profile }}</span>
              </div>
            }
          </div>
        </div>
      </mat-card>
    }

    @if (!loadingEvents && !errorText && events.length > 0) {
      <div class="row overview-items">
        @for (event of events; track event) {
          <div
            class="col-xs-12 col-sm-6 col-lg-4 overview-item"
            >
            <overview-card-old [event]="event"></overview-card-old>
          </div>
        }
        <div class="noMoreEvents">
          <span class="noMoreEventsLabel">{{
            "page.noMoreEvents" | translate
          }}</span>
        </div>
      </div>
    }

    @if (loading) {
      <div class="loading">
        <mat-progress-spinner
          class="loading-spinner"
          [diameter]="75"
          mode="indeterminate"
          color="primary"
          >
        </mat-progress-spinner>
      </div>
    }

    @if (loadingEvents) {
      <div class="loading">
        <mat-progress-spinner
          class="loading-spinner"
          [diameter]="75"
          mode="indeterminate"
          color="primary"
          >
        </mat-progress-spinner>
      </div>
    }

    @if (!loading && error) {
      <div class="errorText">
        {{ "page.error" | translate }}
      </div>
    }
  </div>
